// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"selectGroup__wrapper__HP9Iu","input":"selectGroup__input__eksav","list":"selectGroup__list__28wAe"};


//////////////////
// WEBPACK FOOTER
// ./src/selectGroup/selectGroup.scss
// module id = 207
// module chunks = 0